// extracted by mini-css-extract-plugin
var _1 = "nvLg55BGuUqAy1h9T8Jx";
var _2 = "AC6ljOjEePkp1TpenZmy";
export { _1 as "item", _2 as "list" }
